import { apiSlice } from "../api/apiSlice";

export const marksApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getMarkByAssig: builder.query({
            query: ({ assisId, stdId }) => ({
                url: `assignmentMark?student_id=${stdId}&assignment_id=${assisId}`,
                method: "GET",
            }),
        }),
        getAssigMarkByStdId: builder.mutation({
            query: ( stdId ) => ({
                url: `assignmentMark?student_id=${stdId}`,
                method: "GET",
            }),
        }),
        getQuizMarkByStdId: builder.mutation({
            query: ( stdId ) => ({
                url: `quizMark?student_id=${stdId}`,
                method: "GET",
            }),
        }),
        postMark: builder.mutation({
            query: (data) => ({
                url: "assignmentMark",
                method: "POST",
                body: data,
            }),

          

        }),
        getMarkByvideoandStdId: builder.query({
            query: ({ videoId, stdId }) => ({
                url: `quizMark?student_id=${stdId}&video_id=${videoId}`,
                method: "GET",
            }),
        }),

        postQuizMark: builder.mutation({
            query: (data) => ({
                url: "quizMark",
                method: "POST",
                body: data,
            }),
        
          

        }),

        getAllMarks: builder.query({
            query: () => ({
                url: "assignmentMark",
                method: "GET",
            }),
        }),

        updateMark: builder.mutation({
            query: ({ id, data }) => ({
                url: `assignmentMark/${id}`,
                method: "PATCH",
                body: data,

            }),


         


            
        }),


    }),
});

export const { useUpdateMarkMutation, usePostMarkMutation, useGetMarkByAssigQuery ,useGetAssigMarkByStdIdMutation,useGetQuizMarkByStdIdMutation,usePostQuizMarkMutation,useGetMarkByvideoandStdIdQuery} = marksApi;